// src/components/VariantImageModal.tsx

import React, { useState } from 'react';
import { Modal, Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd/es/upload/interface';
import { apiRequest } from '../../../../service/apiRequest';
import { ProductVariants } from '../../../../types/CreateProductType';

interface Props {
  visible: boolean;
  onCancel: () => void;
  record: ProductVariants;
}

const VariantImageModal: React.FC<Props> = ({ visible, onCancel, record }) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!fileList.length) {
      return message.warning('Please select an image to upload.');
    }

    const formData = new FormData();
    if (record.variant_id != null) { // ✅ null और undefined दोनों check होंगे
      formData.append('variant_id', record.variant_id.toString());
    }
    formData.append('attachments', fileList[0].originFileObj as File);

    try {
      setLoading(true);
      await apiRequest({
        method: 'put',
        url: '/edit-product-variant',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      message.success('Image uploaded successfully');
      onCancel();
    } catch {
      message.error('Upload failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={handleUpload}
      confirmLoading={loading}
      okText="Upload"
      destroyOnClose
      title="Upload Image"
    >
      <Upload
        beforeUpload={() => false}
        listType="picture-card"
        maxCount={1}
        fileList={fileList}
        onChange={({ fileList }) => setFileList(fileList)}
      >
        {fileList.length < 1 && (
          <div style={{ width: 220, height: 220, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <PlusOutlined style={{ fontSize: 24 }} />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        )}
      </Upload>
    </Modal>
  );
};

export default VariantImageModal;
